import { getFontFullPath } from '@/Pages/Clip/SideBar/FontSelector/constants';
import { CaptionLineConfig, CaptionStyles } from '@/domains/asset';
import { TransitionInEffect } from '@/App/remotion/libs/transitions/types';

const custom: Partial<CaptionStyles> = {
  pageStyle: undefined,
  wordStyle: undefined,
  letterStyle: undefined,
  theme_preset: 'custom',
  font_location: getFontFullPath('Bangers-Regular.ttf'),
  caps: false,
  line_config: CaptionLineConfig.OneLine,
  font_size: 102,
  transitions: {
    pageIn: TransitionInEffect.None
  }
};

export default custom;
